export default "__VITE_ASSET__CGhMHzff__"